import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

// project imports
import Loader from 'components/Loader';
import { APP_DEFAULT_PATH } from 'config';
import { selectAuthStatus } from './authSlice';

// ==============================|| AUTH GUARD - GUEST ONLY ||============================== //
// Keeps an already-authenticated user off /login (and avoids flashing the login
// form while a persisted session is still being resolved via GET /auth/me).

export default function GuestGuard() {
  const status = useSelector(selectAuthStatus);

  if (status === 'loading') {
    return <Loader />;
  }

  if (status === 'authenticated') {
    return <Navigate to={APP_DEFAULT_PATH} replace />;
  }

  return <Outlet />;
}
